import { useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import styled from 'styled-components';
import PrivacyPolicyModal from '../Pages/PrivacyPolicyModal';
import { useTranslation } from 'react-i18next';

const BannerInner = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const Text = styled.div`
  font-size: 14px;
  line-height: 1.45;

  @media (max-width: 640px) {
    font-size: 13px;
  }
`;

const PrivacyBtn = styled.button`
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.92);
  padding: 0;
  margin-left: 8px;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 700;

  &:hover {
    opacity: 0.95;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.7);
    outline-offset: 3px;
    border-radius: 8px;
  }
`;

const ButtonsHint = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  @media (max-width: 640px) {
    justify-content: stretch;
  }
`;

export default function CookieBanner() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <CookieConsent
        location="bottom"
        buttonText={t('cookie.accept')}
        declineButtonText={t('cookie.decline')}
        enableDeclineButton
        cookieName="webstore_cookie_consent"
        expires={180}
        style={{
          position: 'fixed',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: 'max(12px, env(safe-area-inset-bottom))',
          width: 'min(1100px, calc(100% - 24px))',
          margin: 0,
          background: 'rgba(0,0,0,0.86)',
          color: '#fff',
          borderRadius: '18px',
          padding: '14px 14px',
          boxShadow: '0 12px 30px rgba(0,0,0,0.35)',
          zIndex: 9999,
          boxSizing: 'border-box',
        }}
        buttonStyle={{
          background: '#b7ff53',
          color: '#0b0b0b',
          fontWeight: 800,
          borderRadius: '999px',
          padding: '10px 14px',
          border: 'none',
          minWidth: '120px',
        }}
        declineButtonStyle={{
          background: 'transparent',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.35)',
          fontWeight: 800,
          borderRadius: '999px',
          padding: '10px 14px',
          minWidth: '120px',
        }}
      >
        <BannerInner>
          <Text>
            {t('cookie.message')}{' '}
            <PrivacyBtn type="button" onClick={() => setPrivacyOpen(true)}>
              {t('cookie.privacyPolicy')}
            </PrivacyBtn>
            .
          </Text>
          <ButtonsHint />
        </BannerInner>
      </CookieConsent>

      <PrivacyPolicyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </>
  );
}
